import moment from 'moment';
import { SearchParams } from '../api/constants';
import { _getEnv, _getUrl } from '../api/utils';
import { ENVIRONMENT } from '../featureFlagsUtils';

export const setToLocalStorage = (key: string, value: string) => {
  localStorage.setItem(key, value);
};

// Used to turn the path into a key for translations and graphics
//
// TODO: Fix this monstrosity
export const getPathKey = (route: string) => {
  if (route.length === 0) {
    return '';
  }

  let updatedRoute = route;

  if (updatedRoute.endsWith('/')) {
    updatedRoute = updatedRoute.slice(0, -1);
  }

  return updatedRoute.slice(1).replaceAll('/', '.');
};

export const getSPMetadataURL = (tenantIdParam?: string) => {
  const tenantId = tenantIdParam
    ? tenantIdParam
    : new URLSearchParams(window.location.search).get(SearchParams.TENANT_ID) || 'no-tenant-id';
  const urls = _getUrl({
    spMetadataUrl: { sub: 'metadata.app', path: `/${tenantId}/saml_metadata/sp_saml_metadata.xml` },
  });
  return urls?.spMetadataUrl;
};

export const getPortalUrl = (tenantId?: string) => {
  const urls = _getUrl({
    portalUrl: { sub: tenantId ? `${tenantId}.access` : 'access', path: '/' },
  });
  return urls?.portalUrl;
};

export function isSetup(): boolean {
  return !!window?.location?.pathname?.startsWith('/setup');
}

export const getUrlParam = (param: string): string | null => {
  return new URLSearchParams(window.location.search).get(param);
};

export const getIDPUrl = (tenantId: string, workflowId: string, isTestTenant = false) => {
  const urls = _getUrl({
    idpUrl: { sub: `${tenantId}.sys`, path: '/idp-web/idp/authenticate' },
  });
  const idpUrl = urls?.idpUrl;

  let targetUrl = getUrlParam('target') || window.location.href;
  if (isTestTenant) {
    targetUrl = `${getPortalUrl(tenantId)}`;
  }
  const idpQueryParams = `?workflowId=${workflowId}&target=${targetUrl}`;
  return `${idpUrl}${idpQueryParams}`;
};

export const getSSOLogoutUrl = (tenantId: string, workflowId: string) => {
  const urls = _getUrl({
    ssoUrl: { sub: `${tenantId}.sys`, path: '/idp-web/idp/start-slo' },
  });
  const idpUrl = urls?.ssoUrl;
  const targetUrl = getUrlParam('target') || getPortalUrl();
  const idpQueryParams = `?workflowId=${workflowId}&target=${targetUrl}`;
  return `${idpUrl}${idpQueryParams}`;
};

export const getIdpLookupUrl = (isTestTenant = false, tenantId?: string) => {
  const urls = _getUrl({
    idpUrl: { sub: 'idp.app', path: '/tenant-lookup' },
  });
  let targetUrl = getUrlParam('target') || window.location.href;
  if (isTestTenant) {
    targetUrl = `${getPortalUrl(tenantId)}`;
  }
  return `${urls?.idpUrl}?target=${targetUrl}`;
};

export const copyToClipboard = (text: string) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      console.debug('Copied to clipboard');
    })
    .catch((e) => {
      console.error(`Copy to clipboard FAILED!: ${text}. E: `, e);
    });
};

// from 1970-01-01T00:00:00Z
// to   1970-01-01 00:03:00 UTC+03 or w/o +03 for UTC
export function formatDateInUtcWithTz(date?: string) {
  if (!date) {
    return null;
  }

  return moment(date)
    .format('YYYY-MM-DD HH:mm:ss [UTC]ZZ')
    .slice(0, -2) // Remove minutes from the TZ. Like +0300 -> +03
    .replace('+00', ''); // If UTC TZ, remove the +00 hours shift altogether
}

export const Regex = {
  // Allowed 0-9, '.', ' ', '-'.
  // Allowed optional '+' at the beginning
  phone: /^\+?[0-9. \-]+$/,
  imprIdPDomain: /^[0-9a-z\-]+$/,
  // Starts or ends with -
  imprIdPDomainHyphens: /^[^-].+[^-]$/,
  // Has - in the 3rd or 4th position
  imprIdPDomainHyphensPosition: /^..[^-][^-]/,
  // Block &=_, etc.; cannot start or end with .
  imprIdPUsername: /^[^.][^&=_'"\-+,<>@\s]+[^.]$/i,
  // Block more than one period (.) in a row
  imprIdPUsernameTwoDots: /^(?!.*\.\.).*$/,
};
